import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import {
  //normalizeRate,
  renderDateField,
  renderTextField,
  normalizeDecimal,
  isCustomReferenceNumber,
} from '../../../../components/reduxFields';
//import { isEmptyObject } from '../../../../actions/utilAction';
import { CommonButton } from '../../../../components/buttons';
import moment from 'moment';
import {saveBatchPaymentDetails } from './actions/ManageClaimActions';

const validateForm = (values) => {
  const errors = {};

  // if (!values.patientInsuranceId) {
  //   if (!Number.isInteger(values.patientInsuranceId)) {
  //     errors.patientInsuranceId = 'Please select insurance company.';
  //   }
  // }

  // if (!values.paymentTypeId) {
  //   if (!Number.isInteger(values.paymentTypeId)) {
  //     errors.paymentTypeId = 'Please select payment type.';
  //   }
  // }

  // if (!values.descriptionTypeId) {
  //   if (!Number.isInteger(values.descriptionTypeId)) {
  //     errors.descriptionTypeId = 'Please select payment description.';
  //   }
  // }

  // // if (!values.chequeNo) {
  // //   errors.chequeNo = 'Please enter reference number.';
  // // }

  // if (!values.Source) {
  //   if (!Number.isInteger(values.Source)) {
  //     errors.Source = 'Please select payment source.';
  //   }
  // }
  // if (!values.guarantorId) {
  //   if (!Number.isInteger(values.guarantorId)) {
  //     errors.guarantorId = 'Please select guarantor name.';
  //   }
  // }

  // if (!values.amount) {
  //   errors.amount = 'Please enter amount.';
  // }
  // if (!values.paymentDate) {
  //   errors.paymentDate = 'Please select payment date.';
  // }

  if (!values.totalCheckAmount) {
    errors.totalCheckAmount = 'Please enter total check amount.';
  }  

  return errors;
};


class AppliedBatchPaymentDetailModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // paymentDate: new Date(),
       depositDate: props.depositDate || null,
      // patientId: props.patientId,
       paymentIds: props.paymentIds,
      // //serviceLineId: props.serviceLineId,
      // sourceArray: [{ id: 1, value: 'Self' },
      //   //{ id: 2, value: 'Guarantor' },
      //   { id: 3, value: 'Insurance' },
      // ],
      // sourceName: '',
      isChequePayment: false,
      // masterPaymentTypes: [],
      // masterPaymentDescription: [],
      paymentDate: null
    };
    // this.handleNewRequest = this.handleNewRequest.bind(this);
    // this.handleSourceChange = this.handleSourceChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.onSubmitPayment = this.onSubmitPayment.bind(this);
  }

  componentWillMount() {
    //console.log('hello')
    // this.props.getPatientGuarantor(this.state.patientId);
    // this.props.getPatientPayers(this.state.patientId, 'ALL');
  }

  componentWillReceiveProps(nextProps) {

    // if (nextProps.depositDate && nextProps.depositDate && nextProps.depositDate !== this.props.depositDate) {
    //   // let sourceName = nextProps.paymentDetails.data.patientInsuranceId ? 'Insurance' : nextProps.paymentDetails.data.guarantorId ? 'Guarantor' : 'Self';
    //   this.setState({
    //     // paymentDate: nextProps.paymentDetails.data.paymentDate || null,
    //     // isChequePayment: nextProps.paymentDetails.data.chequeNo || null,
    //     // sourceName: sourceName,
    //     depositDate: nextProps.depositDate || null,
    //   });
      

      // let paymentTypes = this.props.masterPaymentTypes;
      // if ((sourceName || '').toLowerCase() === 'insurance') {
        
      //   let filterPaymentTypes = paymentTypes.filter((obj) => (obj.key.toLowerCase()).includes('adjustment') || obj.key.toLowerCase() === 'ach'  || obj.key.toLowerCase() === 'cheque_ins' || obj.key.toLowerCase() === 'credit_card_ins'  || obj.key.toLowerCase() === 'cheque' || obj.key.toLowerCase() === 'chk' || obj.key.toLowerCase() === 'non' || obj.key.toLowerCase() === 'patient_responsibility' || obj.key.toLowerCase() === 'reversal_of_previous_payment');
      //   this.setState({
      //     masterPaymentTypes: filterPaymentTypes || [],
      //   });
      // } else {
      //   let filterPaymentTypes = paymentTypes.filter((obj) => obj.associatedEntity.toLowerCase() !== 'insurance');
      //   this.setState({
      //     masterPaymentTypes: filterPaymentTypes,
      //   });
      // }

      // let descriptionTypes = this.props.masterPaymentDescription;
      // if ((sourceName || '').toLowerCase() === 'insurance') {
      //   let filterDescriptionTypes = descriptionTypes;
      //   this.setState({
      //     masterPaymentDescription: filterDescriptionTypes || [],
      //   },()=>{
      //     //this.props.dispatch(change('AppliedBatchPaymentDetailModalForm', 'descriptionTypeId', nextProps.paymentDetails.data.descriptionTypeId));
      //   });
      // } else {
      //   let filterDescriptionTypes = descriptionTypes.filter((obj) => !(obj.key.toLowerCase()).includes('adjustment'));
      //   this.setState({
      //     masterPaymentDescription: filterDescriptionTypes || [],
      //   });
      // }
      
    //}

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.props.closeDialog();
      }
    };
  }

  // handleNewRequest(input, selectedValue) {
  //   input.onChange(selectedValue.value);

  //   if (input.name.toLowerCase() === 'paymenttypeid') {
  //     if (((selectedValue.label || '').toLowerCase() === 'check') || ((selectedValue.label || '').toLowerCase() === 'check ins')) {
  //       this.setState({ isChequePayment: true });
  //     } else {
  //       this.setState({ isChequePayment: false });
  //     }
  //   }
    
  //   if (input.name === 'descriptionTypeId') {
  //     if (this.state.sourceName === 'Insurance') {
  //       let paymentTypes = this.props.masterPaymentTypes;
  //       if ((selectedValue.label || '').toLowerCase() === 'adjustment') {
  //         let filterPaymentTypes = paymentTypes.filter((obj) => (obj.key.toLowerCase()).includes('adjustment') || obj.key.toLowerCase() === 'patient_responsibility');
  //         this.setState({
  //           masterPaymentTypes: filterPaymentTypes || [],
  //         });
  //       }
  //       else if ((selectedValue.label || '').toLowerCase() === 'copayment') {
  //         let filterPaymentTypes = paymentTypes.filter((obj) => obj.key.toLowerCase() === 'cash' || obj.key.toLowerCase() === 'cheque' || obj.key.toLowerCase() === 'credit_card');          
  //         this.setState({
  //           masterPaymentTypes: filterPaymentTypes || [],
  //         });
  //       }
  //       else {
  //         let filterPaymentTypes = paymentTypes.filter((obj) => (obj.key.toLowerCase()).includes('adjustment') || obj.key.toLowerCase() === 'ach'  || obj.key.toLowerCase() === 'cheque_ins'  || obj.key.toLowerCase() === 'credit_card_ins'  || obj.key.toLowerCase() === 'cheque' || obj.key.toLowerCase() === 'chk' || obj.key.toLowerCase() === 'non' || obj.key.toLowerCase() === 'reversal_of_previous_payment');
  //         // console.log('filterPaymentTypes', filterPaymentTypes);
  //         this.setState({
  //           masterPaymentTypes: filterPaymentTypes || [],
  //         });
  //       }
  //     }
  //   }

  // }

  // handleSourceChange(input, selectedValue) {
  //   // console.log('this.props.masterPaymentTypes......', this.props.masterPaymentTypes);
  //   input.onChange(selectedValue.value);
  //   this.setState({ sourceName: (selectedValue.label || '') });
  //   let paymentTypes = this.props.masterPaymentTypes;
  //     if ((selectedValue.label || '').toLowerCase() === 'insurance') {
  //       let filterPaymentTypes = paymentTypes.filter((obj) => obj.associatedEntity.toLowerCase() === 'insurance');
  //       this.setState({
  //         masterPaymentTypes: filterPaymentTypes || [],
  //       });
  //       // console.log('masterPaymentTypes......', this.props.masterPaymentTypes);
  //     } else {
  //       let filterPaymentTypes = paymentTypes.filter((obj) => obj.associatedEntity.toLowerCase() !== 'insurance');
  //       this.setState({
  //         masterPaymentTypes: filterPaymentTypes || [],
  //       });
  //     }
  //     let descriptionTypes = this.props.masterPaymentDescription;
  //     if ((selectedValue.label || '').toLowerCase() === 'insurance') {
  //       let filterDescriptionTypes = descriptionTypes;
  //       this.setState({
  //         masterPaymentDescription: filterDescriptionTypes || [],
  //       });
  //     } else {
  //       let filterDescriptionTypes = descriptionTypes.filter((obj) => !(obj.key.toLowerCase()).includes('adjustment'));
  //       this.setState({
  //         masterPaymentDescription: filterDescriptionTypes || [],
  //       });
  //     }
  // }

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  }

  onSubmitPayment(formData) {
    let formValues = {
      // 'paymentDate': moment(formData.paymentDate).format('YYYY-MM-DDTHH:mm:ss'),
      // 'paymentTypeId': formData.paymentTypeId,
      // 'descriptionTypeId': formData.descriptionTypeId,
      // 'amount': formData.amount,
       'paymentIds': this.state.paymentIds.toString(),
      //'serviceLineId': this.state.serviceLineId,
      'chequeNo': formData.chequeNo || null,
      // 'adjustmentGroupCode': formData.adjustmentGroupCode,
      // 'adjustmentReasonCode': formData.adjustmentReasonCode,
      // 'notes': formData.notes,
      'depositDate': formData.depositDate ? moment(formData.depositDate).format('YYYY-MM-DDTHH:mm:ss') : null,
      'totalCheckAmount': formData.totalCheckAmount,
      'paymentDate':formData.paymentDate ? moment(formData.paymentDate).format('YYYY-MM-DDTHH:mm:ss') : null
      // 'notes': formData.notes || "Apply Payment From Ledger",
    };
    // let sourceName = this.state.sourceName || '';
    // if (sourceName.toLowerCase() === 'self') {
    //   formValues.patientID = this.state.patientId;
    //   formValues.guarantorId = null;
    //   formValues.patientInsuranceId = null;
    // } else if (sourceName.toLowerCase() === 'guarantor') {
    //   formValues.patientID = null;
    //   formValues.guarantorId = formData.guarantorId;
    //   formValues.patientInsuranceId = null;
    // } else {
    //   formValues.patientID = null;
    //   formValues.guarantorId = null;
    //   formValues.patientInsuranceId = formData.patientInsuranceId;
    // }
    //formValues.claimId = this.props.claimId;
    // console.log(JSON.stringify(formValues));
    this.props.saveBatchPaymentDetails(formValues);
    this.props.closeDialog();
  }

  render() {
    const { handleSubmit, open, closeDialog, loading } = this.props;
    //let sourceName = (this.state.sourceName || '').toLowerCase();
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={closeDialog}/>,
      <CommonButton type="submit" primary={true} label= "Save" onTouchTap={handleSubmit(this.onSubmitPayment)}/>,
    ];
    return (
      <Dialog className="custom_modal"
        title={'Edit Bulk Payment Detail' }
        modal={false}
        open={open && !loading}
        actions={actions}
        autoScrollBodyContent={true}>

        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form">
              {/* <div className="row">
                <div className="col-sm-12 col-md-6 require mt-35">
                  <Field
                    name="Source"
                    label="Payment Source"
                    options={this.state.sourceArray}
                    handleNewRequest={this.handleSourceChange}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className={`col-sm-12 col-md-6 ${(sourceName !== 'self') ? 'mt-40' : ''} require`}>
                  {sourceName === 'guarantor' ?
                    (<Field
                      name="guarantorId"
                      label="Guarantor Name"
                      options={guarantors || []}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect}
                    />) : sourceName === 'insurance' ?
                      (<Field
                        name="patientInsuranceId"
                        label="Insurance Company"
                        handleNewRequest={this.handleNewRequest}
                        options={insuranceCompanies || []}
                        component={renderAutoCompleteSingleSelect}
                      />)
                      : ''}
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12 col-md-6 require'>
                  <Field name="paymentDate"
                    placeholder="Check Date"
                    locale="en-US"
                    selected={this.state.paymentDate}
                    onDateChange={this.onDateChange}
                    openToYearSelection = {true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-12 col-md-6 require mt-35">
                  <Field
                    name="descriptionTypeId"
                    label="Payment Description"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterPaymentDescription || []}
                    component={renderAutoCompleteSingleSelect}/>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-12 col-md-6 require mt-35'>
                  <Field
                    name="paymentTypeId"
                    label="Payment Type"
                    handleNewRequest={this.handleNewRequest}
                    options={this.state.masterPaymentTypes || []}
                    component={renderAutoCompleteSingleSelect}/>
                </div>
                <div className="col-sm-12 col-md-6 require">                   
                    <Field
                    name="amount"
                    type="text"
                    maxLength="8"
                    label="Amount($)"
                    component={renderTextField}
                    normalize={normalizeDecimal} />  
                </div>
              </div> */}
              <div className="row">
                {/* {this.state.isChequePayment ? */}
                  <div className="col-sm-12 col-md-6">
                    <Field name="chequeNo"
                      floatingLabelText="Custom Reference Number"
                      maxLength="50"
                      normalize={isCustomReferenceNumber}
                      component={renderTextField} />
                  </div>
                  {/* : null} */}
                  <div className='col-sm-12 col-md-6'>
                    <Field name="depositDate"
                      placeholder="Deposit Date"
                      locale="en-US"
                      selected={this.state.depositDate}
                      onDateChange={this.onDateChange}
                      openToYearSelection = {true}
                      component={renderDateField} />
                  </div>
              </div>
              <div className="row">
                <div className="col-sm-12 col-md-6 require">                   
                      <Field
                      name="totalCheckAmount"
                      type="text"
                      maxLength="8"
                      label="Total Check Amount($)"
                      component={renderTextField}
                      normalize={normalizeDecimal} />  
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <Field name="paymentDate"
                      placeholder="Check Date"
                      locale="en-US"
                      selected={this.state.paymentDate}
                      onDateChange={this.onDateChange}
                      openToYearSelection={true}
                      component={renderDateField} />
                  </div>
              </div>
              {/* <div className="row">
                <div className="col-sm-12 col-md-6 mt-35">
                  <Field
                    name="adjustmentGroupCode"
                    label="Adj. Group Code"
                    handleNewRequest={this.handleNewRequest}
                    options={masterAdjustmentGroupCode || []}
                    component={renderAutoCompleteSingleSelect}/>
                </div>
                <div className="col-sm-12 col-md-6">
                  <Field
                    name="adjustmentReasonCode"
                    type="text"
                    maxLength="5"
                    label="Adj. Reason Code"
                    component={renderTextField}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <Field
                    name="notes"
                    type="text"
                    maxLength="50"
                    label="Notes"
                    component={renderTextField}
                  />
                </div>
              </div> */}
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

//const currentDate = moment().format('YYYY-MM-DDTHH:mm:ss');

function mapStateToProps(state, ownProps) {
  //  console.log('state.billing.claimMasterData.masterPaymentDescription...', state.billing.claimMasterData.masterPaymentDescription);
  let //insuranceCompanies = [],
    // guarantors = [],
    // masterPaymentTypes = [],
    // masterPaymentDescription = [],
    // masterAdjustmentGroupCode = [],
    initialData = {},depositDate = null;
  // if (state.ledger.patientPayers) {
  //   insuranceCompanies = state.ledger.patientPayers.data.length ? state.ledger.patientPayers.data : [];
  // }

  
  // if (state.billing.claimMasterData && state.billing.claimMasterData.masterPaymentType) {
  //   masterPaymentTypes = state.billing.claimMasterData.masterPaymentType;
  // }
  // if (state.billing.claimMasterData && state.billing.claimMasterData.adjustmentGroupCodeModel) {
  //   masterAdjustmentGroupCode = state.billing.claimMasterData.adjustmentGroupCodeModel.map((obj) => {
  //     return {
  //       id: obj.value,
  //       value: obj.value,
  //     };
  //   });
  // }
  // if (state.ledger.patientGuarantors && state.ledger.patientGuarantors.data && !isEmptyObject(state.ledger.patientGuarantors.data)) {
  //   guarantors = state.ledger.patientGuarantors.data.map((obj) => {
  //     return {
  //       id: obj.guardianId,
  //       value: obj.guarantorName,
  //     };
  //   });
  // }

  // if (state.billing.claimMasterData) {
  //   // masterPaymentTypes = state.billing.claimMasterData.masterPaymentType;
  //   masterPaymentDescription = state.billing.claimMasterData.masterPaymentDescription;
  // }
  if (ownProps.paymentIds) {       
    //depositDate = ownProps.depositDate;
    initialData = {chequeNo: ownProps.chequeNo, totalCheckAmount: ownProps.totalCheckAmount, depositDate: ownProps.depositDate} 
  }

  return {
    loading: state.billing.loading,
    //insuranceCompanies: insuranceCompanies,
    //guarantors: guarantors,
    //masterPaymentTypes: masterPaymentTypes || [],
    //masterAdjustmentGroupCode: masterAdjustmentGroupCode || [],
    // masterPaymentDescription: masterPaymentDescription,
    initialValues: initialData,
    //depositDate: depositDate,
   // paymentDetails: state.billing.paymentDetails,
  };
}


AppliedBatchPaymentDetailModal = reduxForm({
  form: 'AppliedBatchPaymentDetailModalForm',
  validate: validateForm,
  enableReinitialize: true,
})(AppliedBatchPaymentDetailModal);

export default connect(mapStateToProps, { saveBatchPaymentDetails })(AppliedBatchPaymentDetailModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/AppliedBatchPaymentDetailModal.js